import axios from 'axios';

export type FetchAutocompleteTagParams = {
  search: string;
  limit?: number;
  lat?: number;
  lng?: number;
};

export type TagsResponse = {
  tags: TagResponse[];
};

export type TagResponse = {
  id: string;
  displayed: boolean;
  slug: string;
  name: string;
  starred: boolean;
  description?: string;
  emoji?: string;
};

export type FetchSimilarTagsParams = {
  id: string;
};

export const fetchAutocompleteTagRequest = async ({ search, limit, lat, lng }: FetchAutocompleteTagParams): Promise<TagResponse[]> => {
  const params = {
    search,
    limit,
    location: lat && lng ? { lat, lng } : undefined
  };
  const { data } = await axios.get<TagsResponse>(`/tag/autocomplete`, { params });
  return data.tags;
};

export const fetchSimilarTagsRequest = async ({ id }: FetchSimilarTagsParams): Promise<TagResponse[]> => {
  const { data } = await axios.get<TagsResponse>(`/tag/${id}/related`);
  return data.tags;
};
